import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=5348f744&"
import script from "./FormTemplate.vue?vue&type=script&lang=js&"
export * from "./FormTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=5348f744&prod&lang=scss&"
import style1 from "./FormTemplate.vue?vue&type=style&index=1&id=5348f744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports